<template>
  <div>
    <com-community-search typeOfView="partner" @search="handleSearch"></com-community-search>
    <com-community-list
      typeOfView="partner"
      :default-params="defaultParams"
      ref="table"
    ></com-community-list>
  </div>
</template>

<script>
  export default {
    props: {
      code: {
        type: String,
        default: ''
      },
      level: {
        type: String,
        default: ''
      }
    },
    watch: {
      code: {
        handler(val) {
          if (val) {
            this.defaultParams.refPartner = val
          }
        },
        deep: true,
        immediate: true
      }
    },
    data() {
      return {
        defaultParams: {},
        activeName: '0'
      }
    },
    methods: {
      handleClick() {
        this.defaultParams.partnerCode = this.code
        this.$refs.table.init()
      },
      handleSearch(val) {
        this.$refs.table.search(val)
      }
    }
  }
</script>

  <style lang="scss" scoped></style>
